<template>
  <div class="feishu-sync-dialog">
    <!-- 同步到飞书 -->
    <el-dialog :title="`同步${syncScopeLabel}到飞书多维表格`" :visible.sync="dialogSyncVisible" width="760px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        将当前{{ syncRangeText }}的「{{ syncScopeLabel }}」同步到飞书多维表格，{{ syncScopeRowHint }}。<br/>
        「月份」若选择「日期」类型，将按「年份 + 月份」写入日期（取当月 1 号）。
      </div>
      <el-form :model="syncForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="syncForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="数据表 ID">
          <div style="display: flex;align-items: center;">
            <el-input v-model="syncForm.table_id" placeholder="tblxxxxxxxxxx（必填）" clearable style="flex:1"/>
            <el-button style="margin-left: 8px;" size="mini" type="primary" plain icon="el-icon-plus"
                       @click="openCreateTableDialog">新增数据表</el-button>
          </div>
        </el-form-item>
        <el-form-item label="写入模式">
          <el-radio-group v-model="syncForm.mode">
            <el-radio label="append">追加（每次同步新增记录）</el-radio>
            <el-radio label="replace">覆盖（先清空目标表再写入）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="syncForm.fields" size="mini" border>
            <el-table-column label="数据源字段" width="200">
              <template slot-scope="{row}">
                <span>{{ row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column label="飞书列名" width="220">
              <template slot-scope="{row}">
                <el-input v-model="row.name" size="mini" placeholder="列名"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="110">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="同步" width="70" align="center">
              <template slot-scope="{row}">
                <el-switch v-model="row.enabled" size="mini"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-copy" style="color:#409EFF"
                       @click="copySyncFieldsAsBitableJson">复制为飞书JSON</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSyncVisible = false">取 消</el-button>
        <el-button @click="handleSaveSyncConfig">保存为全局默认</el-button>
        <el-button type="primary" :loading="syncLoading" @click="handleSyncData" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
      </span>
    </el-dialog>

    <!-- 新增数据表 -->
    <el-dialog :title="`新增数据表（同步${syncScopeLabel}）`" :visible.sync="createTableVisible" width="620px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        在当前多维表格 App 内新建一个数据表，创建成功后会自动把数据表 ID 回填到上方「数据表 ID」。
      </div>
      <el-form :model="createTableForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="createTableForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="表名称">
          <el-input v-model="createTableForm.name" :placeholder="`数据表名称，如：${syncScopeEntity}`" clearable/>
        </el-form-item>
        <el-form-item label="默认视图名">
          <el-input v-model="createTableForm.default_view_name" placeholder="可选，如 表格视图" clearable/>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="createTableForm.fields" size="mini" border>
            <el-table-column label="字段名称">
              <template slot-scope="{row}">
                <el-input v-model="row.field_name" size="mini" placeholder="字段名称"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="150">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="{$index}">
                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                           @click="removeCreateTableField($index)"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-add"
                       @click="createBatchJsonVisible = !createBatchJsonVisible">
              批量粘贴 JSON 生成字段
            </el-button>
            <el-input v-if="createBatchJsonVisible" v-model="createBatchJson" type="textarea" :rows="4"
                      placeholder='JSON 数组，每项生成一行字段，如 [{"field_name":"月份","type":5}]'/>
            <div v-if="createBatchJsonVisible" style="margin-top: 6px;">
              <el-button size="mini" type="primary" @click="applyCreateBatchJson">生成字段</el-button>
            </div>
          </div>
          <el-button style="margin-top: 8px;" type="text" icon="el-icon-plus"
                     @click="addCreateTableField">添加字段</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createTableVisible = false">取 消</el-button>
        <el-button type="primary" :loading="createTableLoading" @click="handleCreateTable">新增数据表</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {feishuCreateTable} from "@/api/feishu";
import {copyToClipboard} from "@/utils/security";

/**
 * 通用「同步到飞书多维表格」弹窗（含新增数据表 / 复制为飞书JSON / 批量粘贴 JSON 生成字段）
 *
 * 用法（宿主组件内）：
 *   <el-button @click="$refs.feishuSyncDialog.open('xxx')" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
 *   <feishu-sync-dialog ref="feishuSyncDialog" :scopes="SYNC_SCOPES" :condition="condition" :params="syncParams"/>
 *
 * scopes 为「维度 key → 配置」映射，每项：
 *   {
 *     label: '展示名（弹窗标题/提示用）',
 *     entity: '数据实体名（建表默认表名/结果提示用）',
 *     rowHint: '每行写入一条记录'（可选，默认「每行写入一条记录」）,
 *     withMonth: false 时默认参数不带 month（可选，默认 true）,
 *     getConfig() / saveConfig(data) / sync(data): 三个接口函数
 *   }
 * params 可选：
 *   - 不传：默认按 condition 组装 {year, [month], organization_id}
 *   - 传 Function(scopeKey) → 返回维度参数对象（如 {before, after, organization_id}）
 *   - 传 Object → 直接作为维度参数
 */
export default {
  name: "FeishuSyncDialog",
  props: {
    // 维度映射：{scopeKey: {label, entity, rowHint, withMonth, getConfig, saveConfig, sync}}
    scopes: {
      type: Object,
      required: true
    },
    // 仪表盘查询条件（year / month / organization_id）
    condition: {
      type: Object,
      default: () => ({})
    },
    // 维度参数（Function(scopeKey) | Object），不传则用 condition 默认组装
    params: {
      type: [Function, Object],
      default: null
    }
  },
  data() {
    return {
      syncScope: '',
      dialogSyncVisible: false,
      syncLoading: false,
      fieldTypeOptions: [
        {value: 1, label: '文本'},
        {value: 2, label: '数字'},
        {value: 3, label: '单选'},
        {value: 5, label: '日期'},
        {value: 7, label: '复选框'}
      ],
      syncForm: {app_token: '', table_id: '', mode: 'append', fields: []},
      createTableVisible: false,
      createTableLoading: false,
      createTableForm: {app_token: '', name: '', default_view_name: '', fields: []},
      createBatchJsonVisible: false,
      createBatchJson: ''
    }
  },
  computed: {
    syncScopeConfig() {
      return this.scopes[this.syncScope] || {}
    },
    syncScopeLabel() {
      return this.syncScopeConfig.label || ''
    },
    syncScopeEntity() {
      return this.syncScopeConfig.entity || this.syncScopeLabel
    },
    syncScopeRowHint() {
      return this.syncScopeConfig.rowHint || '每行写入一条记录'
    },
    // 同步范围文案：如「2024年3月」；按年取数的维度只显示年份
    syncRangeText() {
      const year = this.condition.year || ''
      if (this.syncScopeConfig.withMonth === false) {
        return `${year}年`
      }
      return `${year}年${this.condition.month || ''}月`
    }
  },
  methods: {
    // 打开某维度的同步弹窗
    open(scopeKey) {
      if (!this.scopes[scopeKey]) {
        return
      }
      this.syncScope = scopeKey
      this.dialogSyncVisible = true
      // 拉取该维度的全局默认同步配置填充
      this.scopes[scopeKey].getConfig().then(res => {
        if (res && res.success) {
          this.syncForm.app_token = res.data.app_token || ''
          this.syncForm.table_id = res.data.table_id || ''
          this.syncForm.mode = res.data.mode || 'append'
          this.syncForm.fields = (res.data.fields || []).map(f => ({...f}))
        }
      })
    },
    buildSyncPayload() {
      return {
        app_token: this.syncForm.app_token,
        table_id: this.syncForm.table_id,
        mode: this.syncForm.mode,
        fields: (this.syncForm.fields || []).map(f => ({
          field: f.field,
          name: f.name,
          type: f.type,
          enabled: !!f.enabled
        }))
      }
    },
    // 维度取数参数
    buildSyncParams(scope) {
      if (typeof this.params === 'function') {
        return {...this.params(this.syncScope)}
      }
      if (this.params && typeof this.params === 'object') {
        return {...this.params}
      }
      const out = {year: this.condition.year}
      if (scope.withMonth !== false) {
        out.month = this.condition.month
      }
      out.organization_id = this.condition.organization_id || ''
      return out
    },
    handleSaveSyncConfig() {
      const scope = this.scopes[this.syncScope]
      if (!scope) {
        return
      }
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      scope.saveConfig(this.buildSyncPayload()).then(res => {
        if (res && res.success) {
          this.$message.success('已保存为全局默认同步配置')
        }
      })
    },
    handleSyncData() {
      const scope = this.scopes[this.syncScope]
      if (!scope) {
        return
      }
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      this.syncLoading = true
      const payload = {...this.buildSyncPayload(), ...this.buildSyncParams(scope)}
      scope.sync(payload).then(res => {
        this.syncLoading = false
        if (res && res.success) {
          this.$message.success(`同步成功：共 ${res.data.records || 0} 条${scope.entity}数据，新增 ${res.data.created || 0} 条记录`)
          this.dialogSyncVisible = false
        }
      }).catch(() => {
        this.syncLoading = false
      })
    },
    openCreateTableDialog() {
      // 用当前填写的 app_token 预填，免去重复输入
      this.createTableForm.app_token = this.syncForm.app_token || ''
      this.createTableVisible = true
    },
    // 解析批量粘贴的 JSON（必须是数组）
    parseBatchFieldJson(str) {
      if (!str || !str.trim()) {
        this.$message.warning('请先粘贴 JSON 内容')
        return null
      }
      let parsed
      try {
        parsed = JSON.parse(str)
      } catch (e) {
        this.$message.error('不是合法的 JSON，请检查格式')
        return null
      }
      if (!Array.isArray(parsed)) {
        this.$message.error('需为 JSON 数组，如 [{...},{...}]')
        return null
      }
      return parsed
    },
    // 新增数据表弹窗：批量 JSON 生成字段（一次性追加多行）
    applyCreateBatchJson() {
      const parsed = this.parseBatchFieldJson(this.createBatchJson)
      if (!parsed) {
        return
      }
      const rows = parsed.map(item => ({
        field_name: item.field_name || '',
        type: item.type || 1
      }))
      this.createTableForm.fields.push(...rows)
      this.$message.success(`已批量生成 ${rows.length} 个字段`)
      this.createBatchJson = ''
      this.createBatchJsonVisible = false
    },
    // 同步弹窗：把已启用且有列名的字段导出为飞书多维表格字段 JSON（[{field_name,type}]），供「新增数据表」建列
    copySyncFieldsAsBitableJson() {
      const rows = (this.syncForm.fields || [])
        .filter(item => item.enabled !== false && (item.name || '').trim())
        .map(item => ({
          field_name: (item.name || '').trim(),
          type: item.type || 1
        }))
      if (!rows.length) {
        this.$message.warning('暂无已启用的同步字段可复制')
        return
      }
      copyToClipboard(JSON.stringify(rows)).then(() => {
        this.$message.success(`已复制 ${rows.length} 个飞书多维表格字段的 JSON 到剪贴板`)
      })
    },
    addCreateTableField() {
      this.createTableForm.fields.push({field_name: '', type: 1})
    },
    removeCreateTableField(index) {
      this.createTableForm.fields.splice(index, 1)
    },
    handleCreateTable() {
      if (!this.createTableForm.app_token) {
        this.$message.warning('请填写多维表格 App Token')
        return
      }
      if (!this.createTableForm.name) {
        this.$message.warning('请填写表名称')
        return
      }
      const payload = {
        app_token: this.createTableForm.app_token,
        name: this.createTableForm.name,
        default_view_name: this.createTableForm.default_view_name,
        fields: this.createTableForm.fields.filter(item =>
          item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
      }
      this.createTableLoading = true
      feishuCreateTable(payload).then(res => {
        this.createTableLoading = false
        if (res && res.success) {
          this.createTableVisible = false
          // 新增成功，把新数据表 ID 回填到同步表单
          if (res.data && res.data.table_id) {
            this.syncForm.table_id = res.data.table_id
          }
          this.$message.success('新增数据表成功，已回填数据表 ID')
        }
      }).catch(() => {
        this.createTableLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
